module.exports = __webpack_public_path__ + "media/images/official/special_workcation_06-9831a74475571fa9b6fdca840165d976.jpg";